import { formatHtTreatmentDateDisplay } from './htDisplayFormat';
import { HT_FONT } from './htSheetConstants';

const FOOT_FONT = { ...HT_FONT, size: 8 };

function setFooterCell(ws, r, c, value, opts = {}) {
  const cell = ws.getCell(r, c);
  cell.value = value == null || value === '' ? null : value;
  cell.font = {
    ...FOOT_FONT,
    ...(opts.bold ? { bold: true } : {}),
  };
  cell.alignment = {
    vertical: opts.align?.vertical ?? 'middle',
    horizontal: opts.align?.horizontal ?? 'left',
    wrapText: opts.wrap === true,
    indent: opts.indent ?? 0,
  };
}

/** Pie 54–65 según hoja HT de Invoice 5019 + textos/firmas del PDF. */
export function writeHtFooterExcel(ws, params) {
  const S = params.static;
  const footAlign = { align: { vertical: 'middle', horizontal: 'left' }, indent: 1 };

  setFooterCell(ws, 57, 3, S.HT_ISSUE_PLACE_LABEL, { ...footAlign, bold: true, wrap: false });
  setFooterCell(ws, 58, 3, S.HT_ISSUE_PLACE_EN, { ...footAlign, wrap: false });
  setFooterCell(ws, 59, 3, S.HT_CITY_ISSUE.trim(), { ...footAlign, wrap: false });
  setFooterCell(ws, 61, 3, S.HT_DATE_LABEL, { ...footAlign, wrap: false });
  setFooterCell(
    ws,
    62,
    3,
    formatHtTreatmentDateDisplay(params.certificateIssueDateIso),
    { ...footAlign, wrap: false }
  );

}
